import React, { useEffect } from 'react';
import { NavigationProvider } from './components/Navigation/NavigationContext';
import GlobalNavigation from './components/Navigation/GlobalNavigation';
import MobileMenu from './components/Navigation/MobileMenu';
import ProductsBar from './components/Navigation/ProductsBar';
import SubBrandNavigation from './components/Navigation/SubBrandNavigation';
import ProductNavigation from './components/Navigation/ProductNavigation';
import MainContent from './components/MainContent/MainContent';
import DemoControls from './components/Demo/DemoControls';
import './styles/globals.css';

const App: React.FC = () => {
  useEffect(() => {
    // Set document title
    document.title = 'Modernize - Multi-Level Navigation Prototype';
  }, []);

  return (
    <NavigationProvider>
      <div className="App">
        <ProductsBar />
        <GlobalNavigation />
        <MobileMenu />
        <SubBrandNavigation />
        <ProductNavigation />
        <MainContent />
        <DemoControls />
      </div>
    </NavigationProvider>
  );
};

export default App;
